import { useCallback } from 'react';

import { REFERRAL_SEARCH_PARAMS } from '@contexts/referral-context';

import type {
  CandidateRegistrationStep,
  CandidateRegistrationTab,
} from '../model';

export type CreateReferralSearchParams = ({
  tab,
  step,
  refDeptCode,
  refMagCode,
  refDeptId,
  refBranchId,
  linkId,
}: {
  tab: CandidateRegistrationTab;
  step?: CandidateRegistrationStep;
  refDeptCode?: string | null;
  refMagCode?: string | null;
  refDeptId?: string | null;
  refBranchId?: string | null;
  linkId?: string | null;
}) => {
  search: string;
};

export const useCandidateRegistrationSearchParams = () => {
  const createReferralSearchParams: CreateReferralSearchParams = useCallback(
    ({
      tab,
      step,
      refDeptCode,
      refMagCode,
      refDeptId,
      refBranchId,
      linkId,
    }) => {
      const search = new URLSearchParams();

      search.set(REFERRAL_SEARCH_PARAMS.TAB, tab);

      if (step) search.set(REFERRAL_SEARCH_PARAMS.STEP, step);

      if (refDeptCode) {
        search.set(REFERRAL_SEARCH_PARAMS.REF_DEPT_CODE, refDeptCode);
      }

      if (refMagCode) {
        search.set(REFERRAL_SEARCH_PARAMS.REF_MAG_CODE, refMagCode);
      }

      if (refDeptId) {
        search.set(REFERRAL_SEARCH_PARAMS.REF_DEPT_ID, refDeptId);
      }

      if (refBranchId) {
        search.set(REFERRAL_SEARCH_PARAMS.REF_BRANCH_ID, refBranchId);
      }

      if (linkId) {
        search.set(REFERRAL_SEARCH_PARAMS.GUID, linkId);
      }

      return {
        search: search.toString(),
      };
    },
    []
  );

  return {
    createReferralSearchParams,
  };
};
